import { Link } from "react-router-dom";
import { Lock, Sparkles, Crown } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

// Gate UI for premium features. tier = "pro" | "creator".
export function Paywall({ tier = "pro", feature = "This feature", children }) {
    const { user } = useAuth();
    const ent = user?.entitlements || {};
    // Use the backend's entitlement booleans (true for owner/comped + pro/creator),
    // not a plan-string match — the owner's plan is "owner", not "pro"/"creator".
    const allowed = user?.is_owner || (tier === "creator" ? !!ent.has_creator : !!ent.has_pro);
    if (allowed) return children;

    const Icon = tier === "creator" ? Crown : Sparkles;
    const label = tier === "creator" ? "Creator" : "Pro";

    return (
        <div className="relative" data-testid="paywall">
            <div className="pointer-events-none select-none blur-sm opacity-40 max-h-[420px] overflow-hidden">{children}</div>
            <div className="absolute inset-0 grid place-items-center">
                <div className="text-center bg-surface border border-volt/40 rounded-sm p-7 max-w-md mx-4 shadow-xl">
                    <div className="w-12 h-12 rounded-sm bg-volt/15 border border-volt/40 grid place-items-center mx-auto mb-3">
                        <Lock className="w-5 h-5 text-volt" />
                    </div>
                    <h3 className="font-heading text-xl font-bold mb-1">{feature} is a {label} feature</h3>
                    <p className="text-sm text-muted-foreground mb-5">Start your 7-day free trial to unlock {tier === "creator" ? "the full Creator suite" : "live AI tactical coaching"} — $0 for 7 days.</p>
                    <Link to="/pricing" data-testid="paywall-upgrade"
                        className="inline-flex h-11 px-6 rounded-sm bg-volt text-black font-semibold hover:bg-[#33ceff] items-center gap-2">
                        <Icon className="w-4 h-4" /> Unlock with {label}
                    </Link>
                </div>
            </div>
        </div>
    );
}
